import React from "react";
import { Switch, Route } from "react-router-dom";
import FirstPage from "../views/firstPage/FirstPage"
import CreateAd from "../views/CreateAd";
import Header from "../Components/Header";
import PartnerProgram from "../views/PartnerProgram";
import PersonalPage from "../views/PersonalPage";
import MyAds from "../views/MyAds";
import AlertPage from "../views/AlertPage";
import AdPage from "../views/AdPage";
import MessagePage from "../views/MessagePage";
import SalersRating from "../views/SalersRating";
import SafetyDeal from "../views/SafetyDeal";
import Contacts from "../views/Contacts";
import Service from "../views/Service";
export const useRoutes = (isAuthenticated) => {
  if (isAuthenticated) {
    console.log("login");
    return (
      <Switch>
        <Route path="/" exact></Route>
        <Route path="/ads/:id"></Route>
        <Route path="/profile" exact></Route>
        <Route path="/create" exact></Route>
      </Switch>
    );
  }
  return (
    <Switch>
      <Route path="/create" exact><CreateAd/></Route>
      <Route path="/partner" exact><PartnerProgram/></Route>
      <Route path="/user" ><PersonalPage/></Route>
      <Route path="/myAds" ><MyAds/></Route>
      <Route path="/alert" ><AlertPage/></Route>
      <Route path="/ad/:id" component={AdPage}></Route>
      <Route path="/message" exact component={MessagePage}></Route>

      <Route path="/message/:id" component={MessagePage}></Route>
      <Route path="/rating" ><SalersRating/></Route>
      <Route path="/deal" ><SafetyDeal/></Route>
      <Route path="/contacts" ><Contacts/></Route>
      <Route path="/service" ><Service/></Route>

      <Route path="/" exact><FirstPage/></Route>
      <Route path="/ads/:id"></Route>
      <Route path="/register"></Route>
      <Route path="/login" exact></Route>
    </Switch>
  );
};
